import {
    convertToFormData,
    convertToFormDataKeepArray,
    convertToFormDataForCollective
} from './api.service';

import Vue from 'vue';
import Axios from 'axios';

export const ApiService = {
    query(resource, params, headers = {}) {
        return Vue.prototype.$axios.get(
            resource,
            {
                params: params
            },
            headers
        );
    },

    get(resource, hashid, headers = {}) {
        return Vue.prototype.$axios.get(`${resource}/${hashid}`, {}, headers);
    },

    post(resource, params, headers = {}) {
        return Vue.prototype.$axios.post(`${resource}`, params, headers);
    },

    update(resource, hashid, params, headers = {}) {
        return Vue.prototype.$axios.post(
            `${resource}/${hashid}`,
            params,
            headers
        );
    },

    put(resource, params, headers = {}) {
        return Vue.prototype.$axios.post(`${resource}`, params, headers);
    },

    delete(resource, hashid) {
        return Vue.prototype.$axios
            .delete(`${resource}/${hashid}`)
            .catch((error) => {
                throw new Error(`ApiService ${error}`);
            });
    }
};

export const authService = {
    get_ip() {
        return ApiService.query('ip');
    },
    register(params) {
        return ApiService.post('register', params);
    },
    login(params) {
        return ApiService.post('login', params)
    },
    adminLoginToUserPanel(params) {
        return ApiService.post('login-to-user-panel', params);
    },
    backToAdminPanel(param) {
        return ApiService.post(`back-to-admin-panel`, param);
    },
    verify(params) {
        return ApiService.post('verify-login-code', params)
    },
    verifyRegister(params) {
        return ApiService.post('verify-register-code', params)
    },
    verifyForLogin(params) {
        return ApiService.post('verify-login-code', params)
    },
    verifyG2faForLogin(params) {
        return ApiService.post('/verify-google-2fa', params);
    },
    sendVerify(params) {
        return ApiService.post('send-login-verify-code', params)
    },
    sendVerifyWallet(params) {
        return ApiService.post('wallet/common/change-password/send-code', params)
    },
    sendVerifyRegister(params) {
        return ApiService.post('send-register-verify-code', params)

    },
    logout(params) {
        return ApiService.post('logout', params);
    },
    refreshToken(params) {
        return ApiService.post('refresh-token', params);
    },
    sendForgetPassCode(param) {
        return ApiService.post('forget-password/send-code', param)
    },
    verifyCode(params) {
        return ApiService.post('forget-password/verify-code', params)
    },
    changePass(params) {
        return ApiService.post('forget-password/change-pass', params)
    },
    resendCode(param) {
        return ApiService.post('forget-password/resend-code', param)
    },
    addClickCounter(hashid) {
        return ApiService.get('marketing/add-click-counter', hashid);
    }
};

export const userService = {
    current() {
        return ApiService.query('user/current');
    },
    update(params) {
        return ApiService.post('user/update', params);
    },
    changeUserPhoneNumber(params) {
        return ApiService.post('user/change-user-phone', params);
    },
    verificationPhoneNumber(params) {
        return ApiService.post('user/verify-phone', params);
    },
    update_legal_user(params) {
        return ApiService.post('user/update-legal-user', params);
    },
    authenticate(params) {
        return ApiService.post('user/authenticate', params, {
            'Content-Type': 'multipart/form-data'
        });
    },
    authenticate_legal_user(params) {
        return ApiService.post('user/authenticate-legal-user', params, {
            'Content-Type': 'multipart/form-data'
        });
    },
    delete(hashid) {
        return ApiService.delete('user', hashid);
    },
    restore(hashid) {
        return ApiService.post(`user/restore/${hashid}`);
    },
    find(hashid) {
        return ApiService.query(`user/find/${hashid}`);
    },
    changeUserSetting(hashid, params) {
        return ApiService.post(`user/change-user-setting/${hashid}`, params);
    },
    fetchShebaNumbers(hashid) {
        return ApiService.query(`user/sheba-numbers/${hashid}`);
    },

    fetchBankAccounts(hashid) {
        return ApiService.query(`user/bank-accounts/${hashid}`);
    },

    updateUser(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.post(`user/update-user/${hashid}`, form_data);
    },
    changeAccess(hashid, params) {
        return ApiService.post(`user/change-access/${hashid}`, params);
    },
    changeNotificationAccess(hashid, params) {
        return ApiService.post(
            `user/change-notification-access/${hashid}`,
            params
        );
    },
    fetchForSelect() {
        return ApiService.query('user/for-select');
    },
    changePassword(params) {
        return ApiService.post('user/change-password', params);
    },

    userSetting(params) {
        return ApiService.post('user/user-setting', params);
    },

    getUserSetting() {
        return ApiService.query('user/user-settings', '');
    },

    deleteUserDevice(id) {
        return ApiService.delete(`user/user-settings/devices`, id);
    },

    getUserDevices() {
        return ApiService.query('user/user-settings/devices');
    },

    changeUserPassword(params, header) {
        Vue.prototype.$axios.defaults.headers.common['admin-id'] = header;
        return ApiService.post('user/change-user-password', params);
    },
    fetchReferers() {
        return ApiService.query('user/referers');
    },
    testPosData() {
        return ApiService.query('marketing/pos-statistics/statistics');
    },
    fetchTransactionStatistics(hashid) {
        return ApiService.query(`user/transaction-statistics/${hashid}`);
    },
    fetchActivitiesLogs(hashid) {
        return ApiService.query(`user/activities-logs/${hashid}`);
    },

    countData() {
        return ApiService.query('user/count-data');
    },

    userCountData() {
        return ApiService.query('user/user-count-data');
    },

    countOpenUserTickets(hashid) {
        return ApiService.query('user/count-user-tickets/');
    },

    registerUserByAdmin(params) {
        let form_data = convertToFormData(params);
        return ApiService.post(`/register-by-admin`, form_data);
    },

    generateAccessToken() {
        return ApiService.post('/user/generate-access-token');
    },
    fetchAccessToken() {
        return ApiService.query('/user/fetch-access-token');
    },
    fetchUserG2fa() {
        return ApiService.query(`/user/user-settings/google-2fa`);
    },
    activateAuthUserG2fa(data) {
        return ApiService.post('/user/user-settings/google-2fa/activate', data);
    }
};

export const shaparakService = {
    fetchShaparak(hashid) {
        return ApiService.get('shaparak/shop-requests', hashid);
    },
    resendNewTerminalRequest(hashid) {
        return ApiService.post('shaparak/new-shop', { hashid: hashid });
    },
    changeCreatedRequestStatus(params) {
        return ApiService.post('shaparak/change-request-status', params);
    }
};

export const addressService = {
    fetch() {
        return ApiService.query('address');
    },
    fetchByShopId(params) {
        return ApiService.query('address', params);
    },
    sync(addresses) {
        return ApiService.post('address', addresses);
    },
    delete(hashid) {
        return ApiService.delete(`address/${hashid}`);
    }
};

export const shebaNumberService = {
    fetch() {
        return ApiService.query('sheba-number');
    },
    fetchBankAccount() {
        return ApiService.query('sheba-number/bank-account');
    },
    fetchByShopId(params) {
        return ApiService.query('sheba-number', params);
    },
    fetchIbanList(params) {
        return ApiService.query('sheba-number/list', params);
    },
    sync(params) {
        return ApiService.post('sheba-number', params);
    },
    delete(hashid) {
        return ApiService.delete(`sheba-number/${hashid}`);
    },
    createShebaNumber(params) {
        return ApiService.post(`sheba-number`, params);
    },
    updateShebaNumber(params) {
        return ApiService.post(`sheba-number/${params.id}`, {
            sheba_number: params.number
        });
    },
    deleteShebaNumber(hashid) {
        return Axios.delete(`sheba-number/${hashid}`);
    }
};

export const stakeholdersService = {
    create(params) {
        return ApiService.post('stakeholders/create', params);
    },
    create_wallet_type(params) {
        return ApiService.post('stakeholders/create-wallet-type', params);
    },
    create_psp_type(params) {
        return ApiService.post('stakeholders/create-psp-type', params);
    },
    createFromUsers(params) {
        return ApiService.post('stakeholders/create-from-users', params);
    },
    find(hashid) {
        return ApiService.get('stakeholders/find', hashid);
    },
    update(params, hashid) {
        return ApiService.post(`stakeholders/update/${hashid}`, params);
    },
    update_wallet_type(params, hashid) {
        return ApiService.post(
            `stakeholders/update-wallet-type/${hashid}`,
            params
        );
    },
    update_psp_type(params, hashid) {
        return ApiService.post(
            `stakeholders/update-psp-type/${hashid}`,
            params
        );
    },
    get_status(hashid) {
        return ApiService.get('stakeholders/get-status', hashid);
    },
    update_status(params, hashid) {
        return ApiService.post(`stakeholders/update-status/${hashid}`, params);
    },
    get_selected_shops(hashid) {
        return ApiService.get('stakeholders/get-selected-shops', hashid);
    },
    get_shop_stakeholders(hashid) {
        return ApiService.get('stakeholders/get-shop-stakeholders', hashid);
    },
    get_dedicated_shop_stakeholders(hashid) {
        return ApiService.get(
            'stakeholders/get-dedicated-shop-stakeholders',
            hashid
        );
    },
    get_shop_enabled_stakeholders(hashid) {
        return ApiService.get(
            'stakeholders/get-shop-enabled-stakeholders',
            hashid
        );
    },
    get_dedicated_shop_enabled_stakeholders(hashid) {
        return ApiService.get(
            'stakeholders/get-dedicated-shop-enabled-stakeholders',
            hashid
        );
    },
    get_all_stakeholders() {
        return ApiService.query('stakeholders/get-all');
    },
    get_all_dedicated_stakeholders() {
        return ApiService.query('stakeholders/get-all-dedicated');
    },
    update_shop_stakeholders(params, hashid) {
        return ApiService.post(
            `stakeholders/update-shop-stakeholders/${hashid}`,
            params
        );
    },
    update_dedicated_shop_stakeholders(params, hashid) {
        return ApiService.post(
            `stakeholders/update-dedicated-shop-stakeholders/${hashid}`,
            params
        );
    }
};

export const gatewayService = {
    get_payment_helper_shops() {
        return ApiService.query('gateway/get-payment-helper-shops');
    },
    getSignKey(hashid) {
        return ApiService.query(`gateway/get-sign/${hashid}`);
    },
    fetch(params) {
        return ApiService.query('gateway', params);
    },
    find(hashid) {
        return ApiService.get('gateway', hashid);
    },
    create(params) {
        let form_data = convertToFormDataKeepArray(params);
        return ApiService.post('gateway', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('gateway', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    updateAllowedIps(hashid, ips) {
        return ApiService.post(`gateway/ips/${hashid}`, { ips: ips });
    },
    prepareContract(shop_hashid) {
        return ApiService.post(`gateway/${shop_hashid}/contract`, {});
    },
    listContracts() {
        return ApiService.query('gateway/contract/list');
    },
    contractDetails(contract_hashid) {
        return ApiService.query(`gateway/contract/${contract_hashid}`);
    },
    contractPdf(contract_hashid, download = false) {
        return Vue.prototype.$axios.get(`gateway/contract/${contract_hashid}/pdf`, {
            params: download ? { download: 1 } : {},
            responseType: 'blob'
        });
    },
    acceptContract(contract_hashid, sha256) {
        return ApiService.post(`gateway/contract/${contract_hashid}/accept`, {
            sha256: sha256,
            accepted: true
        });
    },
    sendContractOtp(contract_hashid, sha256) {
        return ApiService.post(`gateway/contract/${contract_hashid}/otp`, {
            sha256: sha256
        });
    },
    signContract(contract_hashid, params) {
        return ApiService.post(`gateway/contract/${contract_hashid}/sign`, params);
    },
    updateSettlementIban(hashid, iban_id) {
        return ApiService.post(`gateway/update-gateway-settlement-iban/${hashid}`, {
            iban_id: iban_id
        });
    },
    delete(hashid) {
        return ApiService.delete(`gateway/${hashid}`);
    },
    changeStatus(hashid, status) {
        return ApiService.post(`gateway/change-status/${hashid}`, {
            status: status
        });
    },
    updateAllowedIps(hashid, ips) {
        return ApiService.post(`gateway/ips/${hashid}`, {'ips' : ips});
    },
    showPSPReportForCommonUser(hashid, status) {
        return ApiService.post(
            `gateway/show-psp-report-for-common-user/${hashid}`,
            {
                status: status
            }
        );
    },
    changeLimitation(hashid, params) {
        return ApiService.post(`gateway/change-limitation/${hashid}`, params);
    },
    changeWage(hashid, params) {
        return ApiService.post(`gateway/change-wage/${hashid}`, params);
    },
    changeSettlementSettings(hashid, params) {
        return ApiService.post(
            `gateway/change-settlement-settings/${hashid}`,
            params
        );
    },
    changeSheba(params) {
        return ApiService.post('gateway/change-sheba', params);
    },
    userChangeShebaRequest(params) {
        return ApiService.post('gateway/user-change-sheba-request', params);
    },
    disableTerminal(params) {
        return ApiService.post('gateway/disable-terminal', params);
    },
    enableTerminal(params) {
        return ApiService.post('gateway/enable-terminal', params);
    },
    changeAddress(params) {
        return ApiService.post('gateway/change-address', params);
    },
    getIp(params) {
        return ApiService.post('gateway/get-ip', params);
    },
    changeGatewayDetails(params) {
        return ApiService.post('gateway/change-details', params);
    },
    fetchNamad(hashid) {
        return ApiService.query(`gateway/enamad/gateway-namad/${hashid}`);
    },
    fetchReportStatistics(hashid, psp) {
        return ApiService.query(
            `gateway/get-transactions-report-statistics/${hashid}?psp=${psp}`
        );
    },
    getGatewayShebaNumbers(hashid) {
        return ApiService.get('gateway/get-gateway-sheba-numbers', hashid);
    },
    getGatewayUsers() {
        return ApiService.query('gateway/user-shop-list');
    },
    getTerminalSettlementSettings(hashid) {
        return ApiService.get(
            'gateway/terminal/settlement-settings/find',
            hashid
        );
    },
    setTerminalSettlementSettings(hashid, params) {
        return ApiService.post(
            `gateway/terminal/settlement-settings/update/${hashid}`,
            params
        );
    }
};

export const ticketService = {
    fetch(params) {
        return ApiService.query('ticket', params);
    },
    find(hashid) {
        return ApiService.get('ticket', hashid);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('ticket', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('ticket', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    categories() {
        return ApiService.query('ticket/fetch/categories');
    },
    submitComment(data) {
        let form_data = convertToFormData(data);
        return ApiService.post('ticket/comment/add', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    delete(hashid) {
        return ApiService.post(`ticket/comment/delete/${hashid}`);
    },
    updateComment(data) {
        let form_data = convertToFormData(data);
        return ApiService.post('ticket/comment/update', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    closeTicket(hashid) {
        return ApiService.post(`ticket/close/${hashid}`);
    },
    fetchSignature() {
        return ApiService.query('ticket/signature');
    },
    updateSignature(params) {
        return ApiService.post('ticket/signature', params);
    },
    findTicket(hashid) {
        return ApiService.get(`ticket/category`, hashid);
    },
    pollTicket(params) {
       return ApiService.post(`ticket/poll`, params);
    }
};

export const dashboardService = {
    fetch() {
        return ApiService.query('dashboard');
    },
    increase(data) {
        return ApiService.post('/gateway/web/payment-request', data);
    }
};
export const newsService = {
    create(params) {
        let form_data = convertToFormData(params);

        return ApiService.post('news/create', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('news', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    deleteNews(hashid) {
        return ApiService.post('news/' + hashid + '/news/delete');
    },
    find(hashid) {
        return ApiService.get('news', hashid);
    },
    CountNewsNotvisited() {
        return ApiService.post('news/Client/Count_News_Not_visited');
    },
    getnews() {
        return ApiService.post('news/Client/getNewsForClient');
    },
    findNewsById(newsid) {
        return ApiService.post('news/Client/findNewsById/' + newsid);
    }
};

export const couponService = {
    fetch() {
        return ApiService.query('store/coupon');
    }
};

export const storeService = {
    fetch() {
        return ApiService.query('store/coupon');
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('store', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('store', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    find(hashid) {
        return ApiService.get('store', hashid);
    },
    publicAccess(slug) {
        return ApiService.get('store-public-access', slug);
    },
    createCoupon(coupon, hashid) {
        let form_data = convertToFormData(coupon);
        return ApiService.post('store/' + hashid + '/coupons/create', coupon, {
            'Content-Type': 'multipart/form-data'
        });
    },
    deleteCoupon(hashid) {
        return ApiService.post('store/' + hashid + '/coupons/delete', {
            'Content-Type': 'multipart/form-data'
        });
    },
    checkCoupon(coupon) {
        return ApiService.post('coupons/check/' + coupon, {
            'Content-Type': 'multipart/form-data'
        });
    }
};

export const productService = {
    fetch() {
        return ApiService.query('product');
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('product', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('product', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    find(hashid) {
        return ApiService.get('product', hashid);
    },
    publicAccess(store, hashid) {
        return ApiService.query('@' + store + '/' + hashid);
    },
    updateTags(tag, hashid) {
        let form_data = convertToFormData(tag);
        return ApiService.post('product/attach/' + hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    detachTags(tag, hashid) {
        return ApiService.post('product/dettach/' + hashid, tag, {
            'Content-Type': 'multipart/form-data'
        });
    },
    createCoupon(coupon, hashid) {
        return ApiService.post('product/discount/create/' + hashid, {
            'Content-Type': 'multipart/form-data'
        });
    }
};

export const pardakhtShakhsiService = {
    fetch() {
        return ApiService.query('factor/get-settings');
    },
    update(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('factor/update-settings', form_data);
    },
    find(hashid) {
        return ApiService.get('pardakht-shakhsi', hashid);
    },
    changeWage(hashid, params) {
        let form_data = { wage: params };
        return ApiService.post(
            `pardakht-shakhsi/change-wage/${hashid}`,
            form_data
        );
    },
    getDirectForm(username) {
        return ApiService.get('pardakht-shakhsi/direct', username);
    },
    newDirectPay(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('pardakht-shakhsi/direct', form_data);
    },
    getCheckoutData(tracking_code) {
        return ApiService.get('pardakht-shakhsi/checkout', tracking_code);
    },
    getReceiptData(tracking_code) {
        return ApiService.get('pardakht-shakhsi/receipt', tracking_code);
    }
};

export const notificationService = {
    fetch() {
        return ApiService.query('notification');
    },
    update(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('notification', form_data);
    },
    fetchTelegramNotification() {
        return ApiService.query('notification-telegram');
    },
    updateTelegram(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('notification-telegram', form_data);
    }
};
export const verifyMailService = {
    verify(tracking_code) {
        return ApiService.get('email-verification', tracking_code);
    }
};

export const pspRequestService = {
    fetch() {
        return ApiService.query('psp-request');
    },
    find(hashid) {
        return ApiService.get('psp-request/find', hashid);
    },
    changeStatus(hashid, status) {
        let form_data = { status: status };
        return ApiService.post(
            `psp-request/change-status/${hashid}`,
            form_data
        );
    },
    changeUserPass(hashid, form_data) {
        return ApiService.post(
            `psp-request/change-user-pass/${hashid}`,
            form_data
        );
    }
};

export const dashboardPluginService = {
    fetchDashboard() {
        return ApiService.query('dashboard/fetch');
    }
};

export const settlementService = {
    changeStatus(hashid, status) {
        return ApiService.post(`settlement/change-status/${hashid}`, {
            status: status
        });
    },
    changeDetailStatus(hashid, status) {
        return ApiService.post(`settlement/change-detail-status/${hashid}`, {
            status: status
        });
    },
    updateSettlement(hashid, params) {
        return ApiService.post(`settlement/update/${hashid}`, params);
    },
    find(hashid) {
        return ApiService.get('settlement/find', hashid);
    },
    fetchFiles() {
        return ApiService.query('settlement/fetch-files');
    },
    createSettlementRequestForStakeholder(params) {
        return ApiService.post(
            'settlement/create-request-for-stakeholder',
            params
        );
    },
    createSettlementRequestForWallet(params) {
        return ApiService.post('settlement/create-request-for-wallet', params);
    }
};

export const paymanService = {
    fetch(params) {
        return ApiService.query('payman', params);
    },
    find(hashid) {
        return ApiService.get('payman/find', hashid);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('payman', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('payman/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    delete(hashid) {
        return ApiService.delete(`payman/${hashid}`);
    },
    changeStatus(hashid, status) {
        return ApiService.post(`payman/change-status/${hashid}`, {
            status: status
        });
    },
    changeWage(hashid, params) {
        return ApiService.post(`payman/change-wage/${hashid}`, params);
    }
};

export const dedicatedService = {
    getSignKey(hashid) {
        return ApiService.query(`dedicated/get-sign/${hashid}`);
    },
    fetch(params) {
        return ApiService.query('dedicated', params);
    },
    fetchPspData(hashid) {
        return ApiService.get('dedicated/psp-data', hashid);
    },
    find(hashid) {
        return ApiService.get('dedicated/find', hashid);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('dedicated/create', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('dedicated/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    updateFullForm(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update(
            'dedicated/update-full-form',
            hashid,
            form_data,
            {
                'Content-Type': 'multipart/form-data'
            }
        );
    },
    delete(hashid) {
        return ApiService.delete(`dedicated/delete/${hashid}`);
    },
    changeSettings(hashid, params) {
        return ApiService.post(`dedicated/change-settings/${hashid}`, params);
    },
    setPSP(hashid, params) {
        return ApiService.post(`dedicated/set-psp/${hashid}`, params);
    },
    changeStakeholdersRequestStatus(params) {
        return ApiService.post(
            'dedicated/change-stakeholders-request-status',
            params
        );
    }
};

export const collectiveService = {
    fetch(params) {
        return ApiService.query('collective', params);
    },
    fetchGeneralSettings(params) {
        return ApiService.query('collective/fetch-general-settings', params);
    },
    find(hashid) {
        return ApiService.get('collective/find', hashid);
    },
    findGate(hashid) {
        return ApiService.get('collective/find-gate', hashid);
    },
    findByShopId(params) {
        return ApiService.query('collective/fetch-by-shop-id', params);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('collective/create', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('collective/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    updateGate(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update('collective/update-gate', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    updateSettings(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('collective/update-settings', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update_wallet_settings(params) {
        return ApiService.post('collective/update-wallet-settings', params);
    },
    get_wallet_settings(params) {
        return ApiService.query('collective/get-wallet-settings', params);
    },
    getUserSwitchingSetting(gateway_hashid) {
        return ApiService.query('collective/get-switching-setting', { gateway_hashid });
    },
    updateUserSwitchingSetting(params) {
        return ApiService.post('collective/update-switching-setting', params);
    }
};

export const transactionService = {
    fetchStatistics(params) {
        let query = {
            query: params
        };
        return ApiService.query('transaction/statistics', query);
    },
    fetchTransaction(query) {
        return ApiService.query('transaction?' + query);
    },
    fetchExcelRequests(query) {
        return ApiService.query('transaction/common-excel-request', query);
    },
    createExcelRequest(params) {
        return ApiService.post('transaction/common-excel-request', params);
    },
    deleteExcelRequest(hashid) {
        return ApiService.delete('transaction/common-excel-request', hashid);
    },
    balanceInquiry(hashid) {
        return ApiService.query(`transaction/${hashid}/balance`, {});
    },
    reverseTransaction(params) {
        return ApiService.post('transaction/reverse-transaction', params);
    },
    fetchRefundMethods() {
        return ApiService.query('transaction/refund-methods');
    },
};

export const marketingService = {
    fetchData(params) {
        let query = {
            query: params
        };
        return ApiService.query('marketing', query);
    },
    fetchMarketingTools() {
        return ApiService.query('marketing/tools');
    },
    fetchSubsets(params) {
        return ApiService.query('marketing', params);
    },
    fetchMarketerSubsets(hashid) {
        return ApiService.query(`marketing/${hashid}/subsets`);
    },
    changeMarketingSetting(params) {
        return ApiService.post('marketing/marketing_setting', params);
    },

    changeSpecificMarketerPercentSetting(params) {
        return ApiService.post(
            'marketing/change-specific-marketer-setting',
            params
        );
    },

    fetchSetting() {
        return ApiService.query('marketing/marketing_setting');
    },
    uploadBanner(params) {
        let form_data = convertToFormData(params);
        return ApiService.post(
            'marketing/marketing_setting/upload_banner',
            form_data
        );
    },
    fetchSpecificMarketerSetting(hashid) {
        let params = {
            hashid: hashid
        };
        return ApiService.query('marketing/specific-marketer-setting', params);
    },
    fetchSubsetTerminals(hashid) {
        return ApiService.query(`marketing/get-subset-terminals/${hashid}`);
    },
    fetchContract() {
        return ApiService.query('marketing/contract');
    },
    contractPdf(download = false) {
        return Vue.prototype.$axios.get('marketing/contract/pdf', {
            params: download ? { download: 1 } : {},
            responseType: 'blob'
        });
    },
    fetchPSPReportStatistics(params) {
        return ApiService.post('marketing/get-psp-report-statistics/', params);
    },
    fetchAppReportStatistics(hashid) {
        return ApiService.query(
            `marketing/get-app-report-statistics/${hashid}`
        );
    },
    getPosStatistics(query) {
        return ApiService.query('marketing/pos-statistics/statistics', query);
    },
    getPosVisitor() {
        return ApiService.query('marketing/pos-acceptor');
    }
};

export const allotmentService = {
    sync(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.post(`allotment/sync/${hashid}`, params);
    },
    find(hashid) {
        return ApiService.get('allotment/find', hashid);
    },

    fetchUserShebas(params) {
        return ApiService.post('allotment/fetch-user-shebas', params);
    },

    update(hashid, params) {
        return ApiService.post(`allotment/update/${hashid}`, params);
    },
    fetch(hashid) {
        return ApiService.get('allotment/fetch', hashid);
    },
    update_dedicated(hashid, params) {
        return ApiService.post(`allotment/update-dedicated/${hashid}`, params);
    },
    fetch_dedicated(hashid) {
        return ApiService.get('allotment/fetch-dedicated', hashid);
    }
};

export const blackListService = {
    addToSuspectedIPs(hashid) {
        return ApiService.post(`blackList/addToSuspectedIPs/${hashid}`);
    },

    addToBlackIPs(hashid) {
        return ApiService.post(`blackList/addToBlackIPs/${hashid}`);
    },

    fetchSuspectedIps() {
        return ApiService.query('blackList/fetchSuspectedIPs');
    },

    fetchBlackIps() {
        return ApiService.query('blackList/fetchBlackIPs');
    },

    deleteFromSuspectedIPs(hashid) {
        return ApiService.post(`blackList/deleteFromSuspectedIPs/${hashid}`);
    },

    deleteFromBlackIPs(hashid) {
        return ApiService.post(`blackList/deleteFromBlackIPs/${hashid}`);
    }
};

export const reportService = {
    fetchGatewaysStatistics(params) {
        let query = {
            query: params
        };
        return ApiService.post('reports/gateways-Statistics', query);
    },

    fetchUsersStatistics(params) {
        let query = {
            query: params
        };
        return ApiService.post('reports/users-Statistics', query);
    },

    gatewayDetails(params) {
        return ApiService.post('reports/gateway-details', params);
    },

    fetchTaxExports() {
        return ApiService.query(`reports/get-tax-exports`);
    },

    fetchUserOfficialFactor(query) {
        return ApiService.query('reports/get-user-official-factor', query);
    },

    userDetails(param) {
        let hashid = {
            hashid: param
        };
        return ApiService.post('reports/user-details', hashid);
    }
};

export const enamadServices = {
    payment(hashid) {
        return Axios.get(`gateway/enamad?shop_id=${hashid}`);
    },
    getStatusCode(hashid) {
        return Axios.get(`gateway/enamad/pay/status?payment_id=${hashid}`);
    },
    getDomainInfo(hashid) {
        return Axios.get(`gateway/enamad/domain-info?shop_id=${hashid}`);
    },
    getNamadCode(hashid) {
        const params = {
            shop_id: hashid
        };

        return Axios.post(`gateway/enamad/retry`, params);
    },
    getNamadInfo(hashid) {
        return Axios.get(`gateway/enamad/domain-info?shop_id=${hashid}`);
    }
};

export const bankAccountsAccessTokenService = {
    storeBankAccountsAccess(params) {
        return ApiService.post(
            'user/user-settings/bank-account-access',
            params
        );
    },
    deactivateBankAccountsAccessAction(hashid) {
        return ApiService.update(
            `user/user-settings/bank-account-access/deactivate-access`,
            hashid,
            {}
        );
    },
    activateBankAccountsAccessAction(hashid) {
        return ApiService.update(
            `user/user-settings/bank-account-access/activate-access`,
            hashid,
            {}
        );
    },
    fetchAccessTokenAuthorizationStatus(track_code) {
        return ApiService.get(
            'user/user-settings/bank-account-access/status',
            track_code
        );
    }
};

export const cardToCardService = {
    fetch(params) {
        return ApiService.query('card-to-card/common', params);
    },
    find(hashid) {
        return ApiService.get('card-to-card/common/gateway', hashid);
    },
    create(params) {
        let form_data = convertToFormDataForCollective(params);
        return ApiService.post('card-to-card/common', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update(
            'card-to-card/common/gateway',
            hashid,
            form_data,
            {
                'Content-Type': 'multipart/form-data'
            }
        );
    },
    deleteBankCard(hashid, gateway_id) {
        return ApiService.delete(
            `card-to-card/common/remove-bank-card/${gateway_id}`,
            hashid
        );
    },
    editBankCard(hashid, gateway_id, params) {
        return ApiService.post(
            `card-to-card/common/edit-bank-card/${gateway_id}/${hashid}`,
            params
        );
    },
    addBankCard(params, gateway_id) {
        return ApiService.post(
            `card-to-card/common/add-bank-card/${gateway_id}`,
            params
        );
    },
    getRechargeData(tracking_code) {
        return ApiService.query(
            `card-to-card/common/get-recharge-result/${tracking_code}`
        );
    },
    rechargeGatewayCredit(gateway_id) {
        return ApiService.post(
            'card-to-card/common/recharge-credit/' + gateway_id
        );
    },
    fetchSetting(gateway_id) {
        return ApiService.get('card-to-card/common/settings', gateway_id);
    },
    updateSetting(params, gateway_id) {
        return ApiService.post(
            'card-to-card/common/settings/' + gateway_id,
            params
        );
    }
};

export const cardToCardWalletService = {
    getSettings() {
        return ApiService.query('card-to-card/wallet/common/settings');
    },

    rechargeWallet(params) {
        let form_data = convertToFormData(params);
        return ApiService.post(
            'card-to-card/wallet/common/recharge',
            form_data
        );
    },
    getRechargeData(tracking_code) {
        return ApiService.query(
            `card-to-card/wallet/common/get-recharge-result/${tracking_code}`
        );
    }
};

export const onlineContractService = {
    getUserContracts() {
        return ApiService.query('online-contract/user-contract');
    },
    createPayment(hashid) {
        return ApiService.post('online-contract/payment/create/' + hashid);
    },
    inquiryPayment(hashid) {
        return ApiService.query('online-contract/payment/inquiry/' + hashid);
    },
    crateSignRequest(hashid) {
        return ApiService.query('online-contract/user-contract/sign/' + hashid);
    },
    requestSendSms(hashid) {
        return ApiService.post('online-contract/user-contract/request-sms/' + hashid);
    },
    verifyContract(hashid, param) {
        return ApiService.post('online-contract/user-contract/verify/' + hashid, param);
    },
};

export const walletService = {
    create(params) {
        return ApiService.post('wallet/common/create', params);
    },
    chargeByDirectPayment(params, hashid) {
        return ApiService.post(
            `wallet/common/charge-by-direct-payment/${hashid}`,
            params
        );
    },
    get(params) {
        return ApiService.query('wallet/common', params);
    },
    getActiveBanks() {
        return ApiService.query('wallet/common/get-active-banks');
    },
    getPin(params) {
        return ApiService.post('wallet/common/get-pin', params);
    },
    cancelSettlement(hashid) {
        return ApiService.post(`wallet/common/cancel-settlement/${hashid}`);
    },
    chargeByOauthDay(params, hashid) {
        return ApiService.post(`wallet/day/charge-by-oauth/${hashid}`, params);
    },
    transferDay(params, hashid) {
        return ApiService.post(`wallet/day/transfer/${hashid}`, params);
    },
    transferAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/transfer/${hashid}`, params);
    },
    settlementDay(params, hashid) {
        return ApiService.post(`wallet/day/settlement/${hashid}`, params);
    },
    settlementAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/settlement/${hashid}`, params);
    },
    settlementAyandeWithExcelRequest(params, hashid) {
        let form_data = convertToFormData(params)     
        return ApiService.post(`wallet/ayande/settlement-by-excel/${hashid}`, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    sendVerificationCode(params) {
        return ApiService.post('wallet/common/change-password/send-code/', params);
    },
    resendSettlement(params) {
        return ApiService.post('wallet/ayande/resend-settlement/', params);
    },
    fetchSettlementAyande(hashid) {
        return ApiService.query(`wallet/ayande/settlement-list/${hashid}`);
    },
    chargeByBill(params, hashid) {
        return ApiService.post(
            `wallet/common/charge-by-bill/${hashid}`,
            params
        );
    },
    getSettlementDetailAyande(hashid) {
        return ApiService.get('wallet/ayande/settlement-detail', hashid);
    },
    getSettlementDetailDay(hashid) {
        return ApiService.get('wallet/day/settlement-detail', hashid);
    },
    chargeByOauthAyande(params, hashid) {
        return ApiService.post(
            `wallet/ayande/charge-by-oauth/${hashid}`,
            params
        );
    },
    chargeBySaderat(params, hashid) {
        return ApiService.post(
            `wallet/ayande/charge-by-saderat/${hashid}`,
            params
        );
    },
    chargeBySaman(params, hashid) {
        return ApiService.post(
            `wallet/ayande/charge-by-saman/${hashid}`,
            params
        );
    },
    getAccessByOauthAyande(params) {
        return ApiService.post(`wallet/ayande/get-access-by-oauth/`, params);
    },
    changePassword(params) {
        return ApiService.post('wallet/common/change-password', params);
    },
    getAutoSettlementSettings(hashid) {
        return ApiService.query(
            `wallet/common/get-auto-settlement-setting/${hashid}`
        );
    },
    setAutoSettlementSettings(params, hashid) {
        return ApiService.post(
            `wallet/common/set-auto-settlement-setting/${hashid}`,
            params
        );
    },
    generateNewSignKey(hashid) {
        return ApiService.post(`wallet/common/generate-new-sign-key/${hashid}`);
    },
    getApiKey(hashid) {
        return ApiService.query(`wallet/common/get-api-key/${hashid}`);
    },
    setSettlementSetting(hashid, payload) {
        return ApiService.post(`wallet/settlement-setting/${hashid}`, payload);
    },
    regenerateInquiryKey(hashid) {
        return ApiService.post(
            `wallet/common/generate-new-inquiry-key/${hashid}`
        );
    },
    regenerateApiKey(hashid) {
        return ApiService.post(`wallet/common/generate-new-api-key/${hashid}`);
    },
    editWalletData(params, hashid) {
        return ApiService.post(
            `wallet/common/edit-wallet-data/${hashid}`,
            params
        );
    },
    userGetTransactionsStats(hashid, query) {
        return ApiService.query(
            `wallet/common/transactions-stats/${hashid}`,
            query
        );
    },
    fetchWalletSettlementRecepit(hashid) {
        return ApiService.get(`wallet/settlement-receipt`, hashid);
    },
    fetchWalletSettlementCollectionReceipt(hashid) {
        return ApiService.get(`wallet/settlement-receipt-collection`, hashid);
    },
    fetchWalletTransaction(hashid) {
        return ApiService.query(
            `wallet/ayande/settlement-list/${hashid}?page=1&perpage=5`
        );
    },
    fetchWalletSettlementData(hashid) {
        return ApiService.query(
            `wallet/common/transactions/${hashid}?page=1&perpage=5`
        );
    },    
    reloadBalance() {
        return ApiService.query('wallet/common/refresh-balance');
    }
};
export const notificationSmsService = {
    fetch() {
        return ApiService.query('notification-sms');
    },
    update(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('notification-sms', form_data);
    },
    updatsetSmsPrice(params) {
        let form_data = convertToFormData(params);
        return ApiService.post('notification-sms/set-sms-price', form_data);
    },
    updateSmsWallet(params) {
        let form_data = convertToFormData(params);
        return ApiService.post(
            'notification-sms/update-sms-wallet',
            form_data
        );
    },
    getRechargeData(tracking_code) {
        return ApiService.query(
            `notification-sms/get-recharge-result/${tracking_code}`
        );
    }
};